import React from 'react'
import BgVideo from "../video/bg-video.mov"

function Index() {
  return (
    <div className='index'>
       <video autoPlay loop muted className="bg-vid">
      <source src={BgVideo} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    </div>
  )
}

export default Index
